/**
 * @file services/queryService.js
 * @description Query/CRM service layer for creating queries, negotiations,
 * custom trip requests, and admin query management.
 */

import api from './api';

const queryService = {
  // Public: create a new query
  createQuery: async (data) => {
    try {
      const response = await api.post('/queries', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Admin: get all queries with filters
  getAllQueries: async (params = {}) => {
    try {
      const response = await api.get('/queries', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Admin: get single query
  getQuery: async (id) => {
    try {
      const response = await api.get(`/queries/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Admin: reply to query thread
  replyToQuery: async (id, content) => {
    try {
      const response = await api.post(`/queries/${id}/reply`, { content });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Admin: update query status/priority
  updateQuery: async (id, data) => {
    try {
      const response = await api.patch(`/queries/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Admin: approve negotiation
  approveNegotiation: async (id, approvedPrice) => {
    try {
      const response = await api.post(`/queries/${id}/approve`, { approvedPrice });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Admin: delete query
  deleteQuery: async (id) => {
    try {
      const response = await api.delete(`/queries/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default queryService;
